import React from "react";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const SETTINGS = {
  starting_modules_selected: "features", location_settings_reviewed: "location",
  labor_law_settings_reviewed: "labor laws", hours_of_operation_reviewed: "hours",
  departments_defined: "departments", departments_created: "departments", departments_reviewed: "departments",
  roles_reviewed: "roles", billing_reviewed: "billing",
};

export function checklistActionLabel(task, action, complete) {
  if (SETTINGS[task.key]) return `${complete ? "Edit" : "Set up"} ${SETTINGS[task.key]}`;
  if (task.key === "training_content_started") return complete ? "View training" : "Set up training";
  if (task.key === "real_location_added") return complete ? "Edit locations" : "Add location";
  return action?.label || "Open";
}

export default function ChecklistActions({ title, main, alternative, options = [], disabled, busy, onMain, onAlternative, onOption, expanded }) {
  const [anchor, setAnchor] = React.useState(null);
  const id = React.useId();
  const buttonClass = "inline-flex h-9 w-[180px] max-w-full items-center justify-center rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600 disabled:opacity-50";
  return <div className="flex shrink-0 flex-wrap items-center justify-end gap-2 md:w-full">
    {alternative && <button type="button" disabled={disabled || busy} onClick={onAlternative} className={buttonClass}>{alternative.label}</button>}
    <div className="w-9 shrink-0">
      {options.length > 0 && <>
        <button type="button" aria-label={`More actions for ${title}`} aria-haspopup="menu" aria-expanded={Boolean(anchor)} aria-controls={anchor ? id : undefined}
          disabled={disabled || busy} onClick={(event) => setAnchor(event.currentTarget)}
          className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600 disabled:opacity-50">
          {busy ? <CircularProgress size={16} color="inherit" /> : <MoreHorizIcon fontSize="small" />}
        </button>
        <Menu id={id} anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
          MenuListProps={{ "aria-label": `Actions for ${title}` }}
          PaperProps={{ sx: { mt: 0.5, border: "1px solid #e2e8f0", borderRadius: "8px", maxWidth: "calc(100vw - 32px)",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)", color: "#334155",
            "& .MuiMenuItem-root": { fontSize: 14, py: 1, whiteSpace: "normal", "&:hover, &.Mui-focusVisible": { bgcolor: "#f5f3ff", color: "#6d28d9" } } } }}>
          {options.map((option, index) => <MenuItem key={index} disabled={disabled || busy} onClick={() => { setAnchor(null); onOption(option); }}>{option.label}</MenuItem>)}
        </Menu>
      </>}
    </div>
    {main && <button type="button" disabled={disabled || busy} onClick={onMain} aria-expanded={expanded} className={buttonClass}>{main.label}</button>}
  </div>;
}
